import {
  createHeaderWithCredentials,
  fetchWithAuth,
  getApiUrl,
  getHeader,
} from '../apiUtils';

const endPoint = 'temporary-data/reflection';

export const postTemporaryDataReflection = async (key: string) => {
  const url = getApiUrl(endPoint);
  const data = { key: Number(key) };
  const header = getHeader({
    method: 'POST',
    body: JSON.stringify(data),
    contentType: 'application/json',
  });

  await fetchWithAuth(url, createHeaderWithCredentials(header));
};
